import { QUICK_INFO_BUTTONS } from '@aibees/elephant/components/quick-info-group/components/quick-info-button';
import { SearchItemUnionProps } from '@aibees/elephant/types';
import { Maybe } from '@aibees/shared/definition';
import type { Dispatch, PropsWithChildren, SetStateAction } from 'react';

export interface ActionButtonContextContextData {
  item?: Maybe<SearchItemUnionProps>;
  setItem: Dispatch<SetStateAction<Maybe<SearchItemUnionProps>>>;
  processingItems?: Maybe<string[]>;
  addProcessingItems: (info: ProcessingItemInfo) => void;
  removeProcessingItems: (info: Omit<ProcessingItemInfo, 'state'>) => void;
  isItemProcessing: (info: Omit<ProcessingItemInfo, 'state'>) => boolean;
  getItemState: (
    info: Omit<ProcessingItemInfo, 'state'>
  ) => ProcessingItemState | undefined;
}

export interface ActionButtonContextContextProps extends PropsWithChildren {
  value?: ActionButtonContextContextData;
}

export interface ProcessingItemInfo {
  id: string;
  type: QUICK_INFO_BUTTONS | 'SAVING';
  state?: ProcessingItemState;
}

export enum ProcessingItemState {
  UNLOCKING = 'UNLOCKING',
  UPDATING = 'UPDATING',
  UPDATING_JOB_CHANGE = 'UPDATING_JOB_CHANGE',
  CHECKING_FOR_UPDATE = 'CHECKING_FOR_UPDATE',
  REVERIFYING = 'REVERIFYING',
}
